var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { getPreferencesStart, getPreferenceSucceeded, getPreferenceFailed, createPreferenceStart, createPreferenceSucceeded, createPreferenceFailed, updatePreferenceStart, updatePreferenceSucceeded, updatePreferenceFailed, } from "./preference.actions";
import { GENERATOR_PARAMS } from "./preference.constants";
var getExtraDefaultState = function () { return ({
    preferences: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(getPreferencesStart.type, function (state, payload) {
    var _a;
    var itemKey = payload.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { isFetching: true, fetchError: undefined }), _a)) });
});
reducer.on(getPreferenceSucceeded.type, function (state, payload) {
    var _a;
    var itemKey = payload.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { hasPreference: true, json: payload.json, isFetching: false, fetchError: undefined }), _a)) });
});
reducer.on(getPreferenceFailed.type, function (state, payload) {
    var _a;
    var itemKey = payload.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { isFetching: false, fetchError: payload.error }), _a)) });
});
reducer.on(createPreferenceStart.type, function (state, payload) {
    var _a;
    var itemKey = payload.data.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { isCreating: true, createError: undefined }), _a)) });
});
reducer.on(createPreferenceSucceeded.type, function (state, payload) {
    var _a;
    var itemKey = payload.data.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { json: payload.data.json, isCreating: false, createError: undefined }), _a)) });
});
reducer.on(createPreferenceFailed.type, function (state, payload) {
    var _a;
    var itemKey = payload.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { json: null, isCreating: false, createError: payload.error }), _a)) });
});
reducer.on(updatePreferenceStart.type, function (state, payload) {
    var _a;
    var itemKey = payload.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { isUpdating: true, updateError: undefined }), _a)) });
});
reducer.on(updatePreferenceSucceeded.type, function (state, payload) {
    var _a;
    var itemKey = payload.data.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { json: payload.data.json, isUpdating: false, updateError: undefined }), _a)) });
});
reducer.on(updatePreferenceFailed.type, function (state, payload) {
    var _a;
    var itemKey = payload.key;
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), (_a = {}, _a[itemKey] = __assign(__assign({}, state.preferences[itemKey]), { isUpdating: false, updateError: payload.error }), _a)) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
